module.exports = __webpack_public_path__ + "static/img/cueb.2d452d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/cueb.png
// module id = x+Dr
// module chunks = 1